import { useState, useEffect } from "react";

import EditModal from "./EditModal";
import PortfolioSection from "./PortfolioSection";
import PortfolioDisplay from "./PortfolioDisplay";

import "./styles/Cards.scss";

// 追加ボタンの文言用（例: 「+ 実績を追加」）
const SECTION_NAMES = {
  achievements: "実績",
  services: "サービス",
};

const isEmptyItem = (item) =>
  !(item?.title || "").trim() && !(item?.description || "").trim();

const PortfolioCard = ({ title, name, items, theme, isEdit, handleEdit }) => {
  const [draftItems, setDraftItems] = useState(items || []);

  useEffect(() => {
    setDraftItems(items || []);
  }, [items]);

  const handleEditData = async () => {
    // タイトル・説明がどちらも空の項目は保存しない（空カードで上限枠を消費しないため）
    const cleaned = (draftItems || []).filter((item) => !isEmptyItem(item));
    await handleEdit({ [name]: cleaned });
  };

  const visibleItems = (items || []).filter((item) => !isEmptyItem(item));

  // 閲覧側では0件のセクションを見せない（編集モードでは追加導線として常に描画する）
  if (!isEdit && visibleItems.length === 0) return null;

  return (
    <div className="card portfolioCard">
      <div
        className={`sectionTitle ${isEdit ? "space" : ""}`}
        style={{ backgroundColor: theme || "#aaa" }}
      >
        <span>{title}</span>
        {isEdit && (
          <EditModal
            size={"md"}
            title={title}
            handleEdit={handleEditData}
            theme={theme}
          >
            <PortfolioSection
              items={draftItems}
              sectionName={SECTION_NAMES[name]}
              onChange={setDraftItems}
            />
          </EditModal>
        )}
      </div>
      <div className="cardContent portfolioContent">
        {visibleItems.length > 0 ? (
          <PortfolioDisplay items={visibleItems} />
        ) : (
          <span className="no-content">データがありません</span>
        )}
      </div>
    </div>
  );
};

export default PortfolioCard;
